import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import Scripts from "./Script";
import { Button, Modal, Row, Col } from "react-bootstrap";
import storage from "../../../../Storage";
import RangeCredit from "../../../Components/Game/Addons";
import Engine from "../Engine";
import { gameCoin } from "../../../../actions/gameCoin";
import { setWallet } from "../../../../actions/gameWallet";
import { setWinnerText, setMeToGame } from "../../../../actions/crashGame";
import { Event, __, isValidNumber, forceSatoshiFormat, User, wait, Game, sendNotfication } from "../../../../Helper";
import Menus from "./Menus";
import AutoBet from "./AutoBet";
import './style2.css';

class ManualBet extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            engine: null,
            buttonText: 'Bet',
            buttonType: 'btn-bet',
            barType: 'next-round',
            inputDisabled: false,
            buttonProgress: null,
            gameStatus: null,
            clicked: false,
            added: false,
            holding: false,
            showNext: true,
            // payout: forceSatoshiFormat(storage.getKey('odd') ? storage.getKey('odd') : 3000.00),
            payout: forceSatoshiFormat(storage.getKey('odd') ? storage.getKey('odd') : 5.00),
            token: storage.getKey('token') ? storage.getKey('token') : null,
            hotkey: storage.getKey('hotkey') ? storage.getKey('hotkey') : "OFF",
            auto: false,
            online_users: 0,
            bid: '',
            our_bid: '',
            activeTab: 'bet',
            activeTab2: 'bet2',
            amount: 50.00,
            isCashingOut: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleBet = this.handleBet.bind(this);
        this.setBet = this.setBet.bind(this);
        this.cancelBet = this.cancelBet.bind(this);
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        if (this._isMounted) {
            const engine = Engine

            this.setState({ engine: engine })

            //Load Coin From Redux
            this.props.gameCoin();

            window.addEventListener('keypress', this.handleHotKey.bind(this));

            // Game Event
            engine.trigger.on("game_status", (data) => this.checkStatus(data));

            engine.trigger.on("waiting_crash", () => this.checkWaitingGame());
            engine.trigger.on("busted_crash", () => this.checkBustedGame());
            engine.trigger.on("started_crash", () => this.checkStartedGame());

            // User Event
            engine.trigger.on("play_crash", data => this.handlePlay(data));
            engine.trigger.on("finish_crash", data => this.handleFinish(data));
            engine.trigger.on("error_crash", data => this.handleError(data));
            engine.trigger.on("stop_playing", () => this.stopManual());
            engine.trigger.on("auto_bet", data => this.handleAuto(data));
        }
    }

    componentWillMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener('keypress', this.handleHotKey.bind(this));
    }

    handleClickOutside(event) {
        let value = parseFloat(this.state.payout);

        if (value < 1.01)
            value = 3.00;

        if (isNaN(value))
            value = 3.00;

        if (value > 1000000)
            value = 1000000;

        this.setState({ payout: parseFloat(value).toFixed(2) });

        var amount = this.wrapperRef.current.value;

        if (amount === '') {
            amount = 50.00;
            this.setState({ amount: 50.00 });
        }

        if (parseFloat(amount) < 10.00) {
            amount = 50.00;
            this.setState({ amount: forceSatoshiFormat(50.00) });
        }

        if (parseFloat(amount) > 3000.00) {
            amount = 3000.00;
            this.setState({ amount: forceSatoshiFormat(3000.00) });
        }

        if (parseFloat(amount) <= 0) {
            amount = 50.00;
            this.setState({ amount: forceSatoshiFormat(50.00) });
        }
        else {
            if (amount === "NaN") amount = 50.00;
            this.setState({ amount: forceSatoshiFormat(amount) });
        }
    }

    handleInputChange(event) {
        let target = event.target;
        let value = target.value;
        let name = target.name;

        if (name === 'amount') {
            if (!isValidNumber(value)) return;
        }

        if (name === 'payout') {
            storage.setKey('odd', value);
            if (value >= 999999) {
                return;
            }
            else if (value === '') {
                sendNotfication("Please Input Minimum Cashout Value of 1.01", 'info', 'top-center');
            }
        }

        if (name === 'amount') {
            storage.setKey('lam', value);
        }

        this.setState({ [name]: value });
    }

    stopManual() {
        this.setState({ started: false, buttonText: 'BET', inputDisabled: false });
    }

    checkStatus(data) {
        if (this._isMounted) {
            switch (data.status) {
                case 'waiting':
                    this.checkWaitingGame();
                    break;
                case 'started':
                    this.checkStartedGame();
                    break;
                case 'busted':
                    this.checkBustedGame();
                    break;
                default:
            }
        }
    }

    handleAuto = (data) => {
        if (this._isMounted) {
            let { amount, payout } = this.state;
            console.log(amount + " - " + payout);

            if (!payout) return alert('payout is empty.');
            if (!amount) return alert('amount is empty.');

            this.setState({ amount: amount, payout: payout, auto: true });

            this.setState({
                added: false,
                inputDisabled: true,
                buttonType: 'btn-bet-success-crash text-dark btn-p no-shadow',
                buttonText: "Automatic"
            });

            if (this.state.gameStatus === 'started') {
                this.holdBet();
            }
            else if (this.state.gameStatus === 'waiting') {
                this.setBet();
            }
        }
    };

    handleError(data) {
        if (this._isMounted) {
            // if (data.our_gid == '0') {
            this.props.setMeToGame(false);

            this.setState({ holding: false, added: false, inputDisabled: false });
            clearInterval(this.state.buttonProgress);
            this.setDefaultButton();

            if (!__.isUndefined(data.code)) {
                if (data.code === 'credit')
                    this.props.setWallet(true, data.uid);
            }

            this.setState({ clicked: false })
            sendNotfication(data.message, 'danger', 'top-center');
            // }
        }
    }

    setDefaultButton = () => {
        if (this._isMounted) {
            clearInterval(this.state.buttonProgress);
            this.setState({
                added: false,
                holding: false,
                inputDisabled: false,
                buttonType: 'btn-bet',
                buttonText: "Bet",
                barType: "next-round",
                showNext: true,
                im_in_game: false,
                isCashingOut: false
            });
        }
    };

    setWaitingButton = () => {
        if (this._isMounted) {
            this.setState({
                added: true,
                inputDisabled: true,
                buttonType: 'btn-bet-success-waiting',
                buttonText: "Please Wait...",
                barType: "next-round",
                showNext: true
            });
        }
    };

    setOutButton = () => {
        if (this._isMounted) {
            this.setState({
                inputDisabled: false,
                buttonType: 'btn-bet-success',
                buttonText: "CANCEL",
                barType: "next-round",
                showNext: true,
                im_in_game: false
            });
        }
    };

    setBet() {
        if (this._isMounted) {
            this.setState({ clicked: true, im_in_game: true });
            let { engine, amount, payout, token } = this.state;
            let { bid } = this.props;

            engine.coin = 'kshs';
            engine.token = token;
            engine.amount = amount;
            engine.payout = parseInt(payout * 100) * parseInt(amount);
            engine.odd = payout;
            engine.bid = bid;
            engine.play();
        }
    }

    cancelBet() {
        if (this._isMounted) {
            let { engine } = this.state;
            engine.isHolding = false;

            this.setDefaultButton();
            this.setState({ holding: false, im_in_game: false });
            sendNotfication("Bet cancelled", 'danger', 'top-center');
        }
    }

    cashOut() {
        if (this._isMounted) {
            let { engine } = this.state;
            clearInterval(this.state.buttonProgress);
            this.setState({
                im_in_game: false,
                isCashingOut: true,
                buttonText: "Cashing Out..",
                buttonType: 'btn-bet-success-progress'
            });
            engine.finish(Game['current_amount']);
        }
    }

    handlePlay(data) {
        if (this._isMounted) {
            if (data.token === this.state.token) {
                this.setState({ im_in_game: true });
                this.props.setMeToGame(true);
            }
        }
    }

    handleFinish(data) {
        if (this._isMounted) {
            if (data.token === this.state.token) {

                this.setState({ isCashingOut: true });
                setTimeout(() => {
                    this.setDefaultButton();
                    this.props.setMeToGame(false);
                    sendNotfication("You Have Won Kes " + forceSatoshiFormat(data.won + data.amount), 'success', 'top-center');
                }, 150);
            }
        }
    }

    checkWaitingGame() {
        if (this._isMounted) {
            this.props.setWinnerText('');

            this.setState({ gameStatus: 'waiting' });

            let { im_in_game } = this.state;
            let { engine, online_users } = this.state;

            let today = new Date()
            let curHr = today.getHours()

            if (curHr < 10) {
                online_users = this.getRandomInt(100, 120);
            }
            else if (curHr < 12) {
                online_users = this.getRandomInt(130, 150);
            } else if (curHr < 18) {
                online_users = this.getRandomInt(290, 310);
            } else if (curHr < 20) {
                online_users = this.getRandomInt(315, 350);
            }
            else {
                online_users = this.getRandomInt(355, 400);
            }
            this.setState({ online_users: online_users });

            if (this.state.holding) {
                this.setState({ holding: false });
                this.placeBet();
            }
        }
    }

    checkStartedGame() {
        if (this._isMounted) {
            this.setState({ gameStatus: 'started', online_users: this.state.online_users });
            let { im_in_game } = this.state;
            let { engine, online_users } = this.state;

            let coin = 'kshs';
            let amount = engine.amount

            let today = new Date()
            let curHr = today.getHours()

            if (curHr < 10) {
                online_users = this.getRandomInt(100, 120);
            }
            else if (curHr < 12) {
                online_users = this.getRandomInt(130, 150);
            } else if (curHr < 18) {
                online_users = this.getRandomInt(290, 310);
            } else if (curHr < 20) {
                online_users = this.getRandomInt(315, 350);
            }
            else {
                online_users = this.getRandomInt(355, 400);
            }

            let game_1_status = localStorage.getItem('game_1');
            let game_2_status = localStorage.getItem('game_2');

            this.setState({ gameStatus: 'started', online_users: online_users });

            if (this.state.bid == 0 && this.state.bid != 1) {
                if ((im_in_game === true && game_2_status === false) || this.state.clicked) {
                    this.setState({ inputDisabled: false, buttonType: "btn-bet-success-crash text-dark", clicked: false });

                    let counter = 0;
                    let self = this;
                    this.state.buttonProgress = setInterval(function () {
                        if (!self.state.isCashingOut) {
                            let calc = amount * (Game['current_amount'] - 1);
                            self.setState({
                                buttonText: ["Cash Out", <br key="br" />, `${forceSatoshiFormat(calc)} KES`],
                                showNext: false,
                                im_in_game: true,
                                buttonType: "btn-bet-success-progress"
                            });
                            counter++;
                            if (parseFloat(Game['current_amount']) >= parseFloat(self.state.payout)) {
                                clearInterval(self.state.buttonProgress);
                                self.cashOut();
                            }
                        }
                    }.bind(this), 50);
                }
            }
        }
    }

    checkBustedGame() {
        if (this._isMounted) {
            this.setState({ gameStatus: 'busted', clicked: false });

            let { im_in_game } = this.state;

            if (!this.state.holding) {
                this.props.setMeToGame(false);
                clearInterval(this.state.buttonProgress);
                this.setDefaultButton();
            }

            if (im_in_game) {
                this.props.setMeToGame(false);
                clearInterval(this.state.buttonProgress);
                this.setDefaultButton();
            }
        }
    }

    isCorrectBet() {
        let { amount, payout } = this.state;

        if (!isValidNumber(amount))
            return false;

        if ((payout * 100) < 100)
            return false;

        if ((payout * 100) === 100)
            return false;

        return true;
    }

    placeBet() {
        if (this._isMounted) {
            let { engine } = this.state;

            engine.isHolding = false;
            this.setWaitingButton();
            this.setBet();
        }
    }

    holdBet() {
        if (this._isMounted) {
            let { engine } = this.state;
            engine.isHolding = true;
            this.setState({ holding: true, im_in_game: false });
            this.setOutButton();
        }
    }

    handleBet(e) {
        if (this._isMounted) {
            e.preventDefault();


            let { amount, payout, holding, gameStatus, token } = this.state;
            let { isLogged, bid } = this.props;

            if (!isLogged) {
                return Event.emit('showAuthModal', true);
            }

            localStorage.setItem("game_1", true);
            localStorage.setItem("game_2", false);

            if (!this.isCorrectBet())
                return false;

            this.setState({ payout: (payout * 1).toFixed(2), auto: false, bid: bid });

            let { im_in_game } = this.state;

            switch (gameStatus) {
                case 'waiting':
                    this.placeBet();
                    break;

                case 'busted':
                    if (holding) {
                        this.cancelBet();
                    }
                    else this.holdBet();
                    break;

                case 'started':
                    if (im_in_game)
                        this.cashOut();
                    else if (holding)
                        this.cancelBet();
                    else
                        this.holdBet();
                    break;
            }
        }
    }

    hotkeyChange() {
        if (this._isMounted) {
            if (this.state.hotkey === "OFF") {
                User['denied_hotkey'] = false;
                storage.setKey("hotkey", 'ON');
                this.setState({ hotkey: "ON" })
            }
            else {
                storage.setKey("hotkey", 'OFF');
                this.setState({ hotkey: "OFF" })
            }
        }
    }

    handleHotKey(e) {
        if (this._isMounted) {
            if (User['denied_hotkey']) {
                User['denied_hotkey'] = false;
                storage.setKey('hotkey', "OFF");
                this.setState({ hotkey: 'OFF' })
            }

            if (storage.getKey('hotkey') === 'ON') {
                var char = e.which || e.keyCode;
                if (char === 98) {
                    this.handleBet(e);
                }
                if (char === 102) {
                    var calc = parseFloat(this.state.payout * 2);
                    var max = Math.max(1.00, calc);
                    this.setState({ payout: max.toFixed(2) })
                }
                if (char === 101) {
                    var calc = parseFloat(this.state.payout / 2);
                    var max = Math.max(1.00, calc);
                    this.setState({ payout: max.toFixed(2) })
                }

                this.handleInputChange(e);
            }
        }
    }

    setMax = (e) => {
        e.preventDefault();
        var max = 200
        if (max === null) return;

        this.setState({ amount: forceSatoshiFormat(max) });
        storage.setKey('lam', forceSatoshiFormat(max));
    };

    setMin = (e) => {
        e.preventDefault();
        this.setState({ amount: '20.00' });
        storage.setKey('lam', '20.00');
    };

    multi = (e) => {
        var max = 50
        this.setState({ amount: forceSatoshiFormat(max) });
        storage.setKey('lam', forceSatoshiFormat(max));
    }

    devide = (e) => {
        var max = 100
        max = Math.max(max, 0.00000010)
        this.setState({ amount: forceSatoshiFormat(max) });
        storage.setKey('lam', forceSatoshiFormat(max));
    }

    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    setActiveTab(tab) {
        this.setState({ activeTab: tab });
    }

    setActiveTab2(tab) {
        this.setState({ activeTab2: tab });
    }

    handleBetAmountClick = (amount, section) => {
        if (section === 'first') {
            this.setState({ amount: amount });
        } else if (section === 'second') {
            this.setState({ secondBetAmount: amount });
        }
    };

    incrementAmount = (section) => {
        if (section === 'first') {
            this.setState(prevState => ({
                amount: Math.min(parseFloat("{{maxBetAmount}}") || 10000, prevState.amount + 10)
            }));
        } else if (section === 'second') {
            this.setState(prevState => ({
                secondBetAmount: Math.min(parseFloat("{{maxBetAmount}}") || 10000, prevState.secondBetAmount + 10)
            }));
        }
    };

    decrementAmount = (section) => {
        if (section === 'first') {
            this.setState(prevState => ({
                amount: Math.max(10, prevState.amount - 10)
            }));
        } else if (section === 'second') {
            this.setState(prevState => ({
                secondBetAmount: Math.max(10, prevState.secondBetAmount - 10)
            }));
        }
    };

    incrementPayout = () => {
        this.setState(prevState => {
            const newPayout = Math.min(1000000, parseFloat(prevState.payout) + 0.01).toFixed(2);
            storage.setKey('odd', newPayout);
            return { payout: newPayout };
        });
    };

    decrementPayout = () => {
        this.setState(prevState => {
            const newPayout = Math.max(1.01, parseFloat(prevState.payout) - 0.01).toFixed(2);
            storage.setKey('odd', newPayout);
            return { payout: newPayout };
        });
    };

    render() {
        let { amount, inputDisabled, payout, buttonType, barType, buttonText, hotkey, showNext, activeTab, activeTab2, secondBetAmount } = this.state;
        let { mobile, coin, isLogged } = this.props;
        let hotKeyColor = (hotkey === "OFF") ? 'label-grey' : 'label-success';

        if (amount === "NaN") amount = 50.00;

        let winnings = amount * payout;

        return (
            <div onKeyPress={(e) => this.handleHotKey(e)}>
                <>
                    <div className="betAuto-tab" id="betbox-ui">
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <div className="betAuto-tab-col first-game py-4">
                                    <div className="tab-content">
                                        {activeTab === 'bet' && (
                                            <div className="tab-pane fade show active" id="bet1" role="tabpanel">
                                                <form className="w-100 tbet-tp" onSubmit={(e) => { this.handleBet(e) }}>
                                                    <div className="bet-controlar">
                                                        <div className="row">


                                                            <div className="bet-block col-6">
                                                                <div className="form-spinner first">
                                                                    <a
                                                                        className="btn btn-sm btn-decrement btn-decrement-first first text-white"
                                                                        onClick={() => this.decrementAmount('first')}
                                                                    >
                                                                        -
                                                                    </a>
                                                                    <input
                                                                        type="number"
                                                                        data-type="number"
                                                                        step={10}
                                                                        min={10}
                                                                        max="{{maxBetAmount}}"
                                                                        value={amount}
                                                                        onChange={(e) => this.setState({ amount: parseFloat(e.target.value) })}
                                                                        id="spinner1"
                                                                        className="manualBet first betting-input betting-input-first first"
                                                                    />
                                                                    <a
                                                                        className="btn btn-sm btn-increment btn-increment-first first text-white"
                                                                        onClick={() => this.incrementAmount('first')}
                                                                    >
                                                                        +
                                                                    </a>
                                                                </div>
                                                                <div className="bets-opt-list">
                                                                    {[100, 200, 500, 5000].map((val) => (
                                                                        <a
                                                                            key={val}
                                                                            value={val}
                                                                            className="btn betting-number first"
                                                                            onClick={() => this.handleBetAmountClick(val, 'first')}
                                                                        >
                                                                            {val} <sub>KES</sub>
                                                                        </a>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div className="button-section col-6">
                                                                <Button
                                                                    variant={'btn ' + buttonType}
                                                                    disabled={inputDisabled}
                                                                    type="submit"
                                                                >
                                                                    {buttonText}
                                                                    {buttonType === 'btn-bet-success-progress' ? null : (
                                                                        <p className="mb-0 text-dark" style={{ fontSize: '16px' }}>
                                                                            <span className="bet-button-amount bet-button-amount-first" id="bet-button-amount">
                                                                                {amount.toFixed(2)} KES
                                                                            </span>
                                                                        </p>
                                                                    )}
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="bet-controlar" style={{ display: 'block' }}>
                                                        <div className="bet-cashout auto-cashout autoBetsection mt-3 mx-1 py-1">
                                                            {/* <div className="bet-cashout pl-1">
                                                                <label className="bet-cashout-title">Auto</label>
                                                                <div className="custom-control custom-switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="custom-control-input"
                                                                        id="customSwitch1"
                                                                        name="customSwitch1"
                                                                    />
                                                                    <label className="custom-control-label" htmlFor="customSwitch1" />
                                                                </div>
                                                            </div> */}
                                                            <div className="bet-cashout">
                                                                <label className="bet-cashout-title">Cashout (x)</label>
                                                                <div className="bet-controlar" style={{marginLeft:'40px'}}>
                                                                    <div className="bet-block">
                                                                        <div className="form-spinner first" style={{width:'180px',marginLeft:'20px'}}>
                                                                            <a
                                                                                className="btn btn-sm btn-decrement btn-decrement-first first text-white"
                                                                                onClick={() => this.decrementPayout()}
                                                                            >
                                                                                -
                                                                            </a>
                                                                            <input
                                                                                type="number"
                                                                                data-type="number"
                                                                                step="0.01"
                                                                                min="1.01"
                                                                                max="3000"
                                                                                value={payout}
                                                                                name="payout"
                                                                                onChange={this.handleInputChange}
                                                                                disabled={inputDisabled}
                                                                                className="manualBet first betting-input betting-input-first first"
                                                                            />
                                                                            <a
                                                                                className="btn btn-sm btn-increment btn-increment-first first text-white"
                                                                                onClick={() => this.incrementPayout()}
                                                                            >
                                                                                +
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="bet-controlar" style={{ display: 'block' }}>
                                                        <div className="possible-win mt-3 mx-2 py-1">
                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <h6>POSSIBLE WIN</h6>
                                                                </div>
                                                                <div className="col-6">
                                                                    <h6 className="amount mr-2">KES {parseFloat(winnings).toFixed(2)}</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </div>
        );
    }
}

class HotKey extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            effect: 'pulse'
        };
    }

    toggleModal = (e) => {
        if (e !== undefined)
            e.preventDefault();

        this.setState({ show: !this.state.show, effect: !this.state.show ? 'zoomIn' : 'zoomOut' });
    };

    render() {
        return (
            <>
                <button className={'btn btn-xs stc mt-1 pl-1'} onClick={e => this.toggleModal(e)}>
                    <i className={'cp mdi mdi-information text-info font-15'} />
                </button>
                <Modal
                    size="md"
                    centered={true}
                    backdrop="static"
                    show={this.state.show}
                    onHide={this.toggleModal}
                    aria-labelledby="help-lg-modal"
                    className={"animated " + this.state.effect}
                >
                    <Modal.Header>
                        Hot Keys
                        <button type="button" className="close p-2" onClick={e => this.toggleModal(e)}>
                            <i className={'mdi mdi-close'} />
                        </button>
                    </Modal.Header>
                    <Modal.Body closeButton className="modal-helper text-center">
                        <Row className="shortcut-helper">
                            <Col sm="12">
                                <span className="badge badge-soft-danger">B</span>
                                <i className="mdi mdi-arrow-right align-middle"></i>
                                <span className="badge badge-soft-secondary"> BET</span>
                            </Col>
                            <Col sm="12" className="my-2">
                                <span className="badge badge-soft-danger"> E</span>
                                <i className="mdi mdi-arrow-right align-middle"></i>
                                <span className="badge badge-soft-secondary"> HALF PAYOUT</span>
                            </Col>
                            <Col sm="12">
                                <span className="badge badge-soft-danger"> F</span>
                                <i className="mdi mdi-arrow-right align-middle"></i>
                                <span className="badge badge-soft-secondary"> DOUBLE PAYOUT</span>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

ManualBet.propTypes = {
    coin: PropTypes.string,
    im_in_game: PropTypes.bool,
    credit: PropTypes.string
};

const mapStateToProps = state => ({
    coin: state.items.coin,
    im_in_game: false,
    credit: state.items.credit
});

export default connect(mapStateToProps, { gameCoin, setWinnerText, setMeToGame, setWallet })(ManualBet);